import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import dispatchDomEvent from '../../utils/dispatchDomEvent';
import CheckboxProps from './Checkbox.types';
import styles from './Checkbox.module.scss';

/**
 * The Checkbox needs to be rendered via the InputField (type=checkbox)
 */

const Checkbox = ({
  value,
  checked,
  dataPointer,
  onChange,
  disabled = false,
  id,
  invalid,
  dataCy = 'checkbox',
  color = 'primary',
  errorMsgHolderId,
}: CheckboxProps) => {
  const checkbox = useRef(null);
  useEffect(() => {
    dispatchDomEvent(checkbox.current, 'click');
  }, []);
  return (
    <span
      className={cx({
        [styles.checkboxWrapper]: true,
        [styles.labelWrapperDisabled]: disabled,
      })}>
      <input
        defaultChecked={checked}
        data-cy={dataCy}
        type='checkbox'
        value={value}
        className={cx({
          [styles.checkboxDisabled]: disabled,
          [styles.input]: true,
        })}
        data-pointer={dataPointer}
        onClick={onChange}
        ref={checkbox}
        id={id}
        disabled={disabled}
        aria-invalid={invalid}
        aria-errormessage={errorMsgHolderId}
      />
      <span
        className={cx(
          {
            [styles.tickWrapper]: true,
            [styles.checkboxWrapperDisabled]: disabled,
            [styles.invalid]: invalid,
          },
          styles[color]
        )}>
        <svg
          width='14'
          height='10'
          viewBox='0 0 14 10'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className={styles.tick}>
          <path
            d='M5.49956 7.37912L12.3936 0.484375L13.4548 1.54488L5.49956 9.50012L0.726562 4.72712L1.78706 3.66663L5.49956 7.37912Z'
            fill='white'
          />
        </svg>
      </span>
    </span>
  );
};

export default Checkbox;
